type IconProps = { class?: string };

/** 搜索；源 `icons/header/search.svg`（stroke=currentColor 跟主题） */
export const IconSearch = (props: IconProps) => (
  <svg
    class={props.class || ''}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M21 21L16.542 16.5"
      stroke="currentColor"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle cx="11.042" cy="10.5" r="8" stroke="currentColor" stroke-width="1.67" />
  </svg>
);

/** 转股记录入口：列表文档图标；源 `assets/stock-transfer-in/records-list.svg`（stroke=currentColor 跟主题） */
export const IconRecordsList = (props: IconProps) => (
  <svg
    class={props.class || ''}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect
      x="4.85156"
      y="20.3008"
      width="16.6021"
      height="14.2962"
      rx="0.1"
      transform="rotate(-90 4.85156 20.3008)"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path d="M7.84961 7.84961H16.1506" stroke="currentColor" stroke-width="1.5" />
    <path d="M7.84961 11.5391H16.1506" stroke="currentColor" stroke-width="1.5" />
    <path d="M7.84961 15.2285H10.6166" stroke="currentColor" stroke-width="1.5" />
  </svg>
);

/** 券商 logo 空占位；源 `test/TablerPhoto.svg`（stroke=currentColor 跟主题） */
export const IconPhotoPlaceholder = (props: IconProps) => (
  <svg
    class={props.class || ''}
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
      <path d="M15 8h.01M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z" />
      <path d="m3 16l5-5c.928-.893 2.072-.893 3 0l5 5" />
      <path d="m14 14l1-1c.928-.893 2.072-.893 3 0l3 3" />
    </g>
  </svg>
);

/** 申请已提交：实心圆 + 白勾（避免 Mage 复合 path 缩放灰边）；源 `assets/stock-transfer-in/submitted-check-circle.svg` */
export const IconSubmittedCheckCircle = (props: IconProps) => (
  <svg
    class={props.class || ''}
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle class="sti-submitted-check-circle" cx="12" cy="12" r="10.25" />
    <path
      class="sti-submitted-check-mark"
      d="M7.85 12.35 10.55 15.05 16.15 9.35"
      fill="none"
      stroke="#ffffff"
      stroke-width="2.15"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
